import React, { useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import OverLoading from '../global/OverLoading';
import { getStaffs, deleteStaff } from '../../actions/admin/staffAction';
import { updateModalContent, toggleModal } from '../../actions/modal';
import UpdateStaff from './update';

const themeTable = createMuiTheme({
  overrides: {
    MuiTableRow: {
      root: {
        '&:hover': {
          transition:      '0.3s ease',
          backgroundColor: '#55efc4',
          fontWeight:      '400',
        },
      },
    },
  },
});

const StaffTable = ({ getStaffs, deleteStaff, updateModalContent, toggleModal, updateListOnCreate, resetValue }) => {
  const tableRef = useRef(null);
  const formCreateRef = useRef();
  const [staffs, setStaffs] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [staffId, setStaffId] = useState('');
  const [staffEmail, setStaffEmail] = useState('');

  const fetchStaffs = async () => {
    const res = await getStaffs();
    if (res) {
      setStaffs(res);
    }
  };

  useEffect(() => {
    fetchStaffs();
  }, []);

  useEffect(() => {
    fetchStaffs();
    resetValue();
  }, [updateListOnCreate]);

  const updateTableData = () => {
    fetchStaffs();
  };

  const onUpdateStaff = (id) => {
    updateModalContent({
      title:            'Update Staff',
      content:          <UpdateStaff updateList={() => updateTableData()} staffId={id} ref={formCreateRef} />,
      cancelText:       'Cancel',
      closeAfterAction: false,
      width:            950,
    });

    toggleModal();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setStaffId();
    setStaffEmail();
  };

  const confirmDelete = async () => {
    try {
      setLoading(true);
      await deleteStaff(staffId).then((response) => {
        if (response.status === 200) {
          toast.success('Staff has been deleted.');

          handleCloseModal();
          setLoading(false);
          fetchStaffs();
        } else {
          setLoading(false);
          toast.error('An unexpected error has occurred');
        }
      });
    } catch (err) {
      setLoading(false);
      toast.error(err);
    }
  };

  return (
    <div>
      {loading && <OverLoading />}
      <ThemeProvider theme={themeTable}>
        <MaterialTable
          tableRef={tableRef}
          title=""
          columns={[
            { title: 'Id', field: 'id', width: '20%' },
            { title: 'Email', field: 'email', width: '40%'  },
            { title: 'Position', field: 'position',  width: '40%', filtering: false },
          ]}
          data={staffs || []}
          actions={[
            {
              icon:    'account_circle',
              tooltip: 'Manage',
              align:   'center',
              onClick: (event, staff) => {
                onUpdateStaff(staff.id);
              },
            },
            {
              icon:    'delete',
              tooltip: 'Delete Staff',
              align:   'center',
              onClick: (event, staff) => {
                setOpenModal(true);
                setStaffId(staff.id);
                setStaffEmail(staff.email);
              },
            },
          ]}
          options={{
            actionsColumnIndex:  -1,
            filtering:           true,
            search:              false,
            sorting:             false,
            paging:              true,
            emptyRowsWhenPaging: false,
            headerStyle:         {
              fontSize: 16,
            },
            cellStyle: {
              fontSize: 16,
            },
          }}
        />
      </ThemeProvider>
      <Dialog
        fullWidth
        size="sm"
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Staff</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p style={{ color: '#000000', fontSize: 18, fontWeight: 'bold' }}>{staffEmail}</p>
            Are you sure you want to delete this staff?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">Cancel</Button>
          <Button onClick={(e) => { confirmDelete(e); }} color="secondary">Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapActionToProps = {
  getStaffs,
  deleteStaff,
  updateModalContent,
  toggleModal,
};

// connect(mapStateToProps, actions to component as props)(component)
export default connect(
  null, mapActionToProps,
)(StaffTable);
